// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_enum-bug-keys.js
// module id = qGBL
// module chunks = 1